module.exports = __webpack_public_path__ + "static/media/new-window-icon.91600855.svg";